import ExpandLess from "@mui/icons-material/ExpandLess";
import ExpandMore from "@mui/icons-material/ExpandMore";
import { List, ListItemButton, ListItemIcon, ListItemText, Collapse, Tooltip } from "@mui/material";
import Divider from "@mui/material/Divider";
import { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";

import HNSColors from "../../../../components/ui library/HNSColors";

export default function DropdownMenu({
  icon,
  sideBarIsOpen,
  setSideBarIsOpen,
  closeDropdowns,
  Menu,
  isActiveDropdownURL,
  triggerDropdown,
}) {
  const { title, menuItems } = Menu;
  const { pathname } = useLocation();

  const [openCollapse, setOpenCollapse] = useState(false);
  const [tooltipOpen, setTooltipOpen] = useState(false);

  const navigate = useNavigate();

  const handleNavigate = (url) => {
    if (url.includes("analytics")) {
      setSideBarIsOpen(false);
      triggerDropdown();
    }
    navigate(url);
  };

  useEffect(() => {
    if (closeDropdowns) {
      setOpenCollapse(false);
    }
  }, [closeDropdowns]);

  const isUserManagement = title === "User Management";

  const handleToggle = (e) => {
    e.stopPropagation();
    setTooltipOpen(false);
    if (!sideBarIsOpen) {
      setSideBarIsOpen(true);
    }
    setOpenCollapse((p) => !p);
  };

  return (
    <>
      <div className="mb-1 w-full rounded-md">
        {isUserManagement && <Divider sx={{ marginBottom: 3, marginTop: 1 }} variant="middle" />}
        <Tooltip
          title={title}
          placement="right"
          open={tooltipOpen}
          disableHoverListener={sideBarIsOpen || isActiveDropdownURL}
          onOpen={() => setTooltipOpen(true)}
          onClose={() => setTooltipOpen(false)}
        >
          <ListItemButton
            onClick={handleToggle}
            sx={{
              marginLeft: sideBarIsOpen ? 1.5 : 0.9,
              marginRight: 1.2,
              borderRadius: 1.2,
              marginBottom: 1,
              py: 0.7,
              minHeight: 42,
              backgroundColor: isActiveDropdownURL ? HNSColors.tertiary[900] : "transparent",
              pl: sideBarIsOpen ? 0.5 : 1,
              pr: 1,
              justifyContent: sideBarIsOpen ? "flex-start" : "center",
              color: HNSColors.primary[600],
              borderLeft:
                isActiveDropdownURL && sideBarIsOpen
                  ? `4px solid ${HNSColors.tertiary[400]}`
                  : "4px solid transparent",
            }}
          >
            {isActiveDropdownURL && !sideBarIsOpen && (
              <span
                style={{
                  width: "5px",
                  backgroundColor: HNSColors.tertiary[400],
                  borderRadius: "15px",
                  position: "absolute",
                  height: "36px",
                  top: "3px",
                  left: "-13px",
                }}
              />
            )}
            <ListItemIcon
              sx={{
                minWidth: 32,
                justifyContent: "center",
                alignSelf: isUserManagement ? "flex-start" : "",
              }}
            >
              {icon}
            </ListItemIcon>
            {sideBarIsOpen && (
              <ListItemText
                primary={title}
                sx={{
                  ml: 1,
                  span: { fontSize: 14, fontWeight: 600 },
                  color: isActiveDropdownURL ? HNSColors.primary[600] : HNSColors.neutrals[300],
                }}
              />
            )}
            {sideBarIsOpen && (openCollapse ? <ExpandLess /> : <ExpandMore />)}
          </ListItemButton>
        </Tooltip>
      </div>
      <Collapse in={openCollapse} timeout="auto" unmountOnExit>
        <List
          component="div"
          disablePadding
          sx={{
            ml: 1,
            pl: 1,
          }}
        >
          {menuItems.map((item, index) => (
            <div key={item.key || item.title} style={{ position: "relative" }} className="mb-2">
              {!isUserManagement && (
                <>
                  <span
                    style={{
                      position: "absolute",
                      left: "-25px",
                      top: "50%",
                      transform: "translateY(-50%)",
                      width: "8.2px",
                      height: "8.2px",
                      borderRadius: "50%",
                      backgroundColor:
                        item.url === pathname ? HNSColors.tertiary[400] : HNSColors.neutrals[700],
                      border: "2px solid white",
                      zIndex: 1,
                    }}
                  />
                  <div
                    style={{
                      position: "absolute",
                      left: "-22px",
                      top: 0,
                      bottom: index === menuItems.length - 1 ? 0 : "-12px",
                      width: "2px",
                      backgroundColor: HNSColors.neutrals[800],
                    }}
                  />
                </>
              )}
              <ListItemButton
                onClick={() => handleNavigate(item.url)}
                sx={{
                  mr: 5.7,
                  py: 0,
                  px: 1.3,
                  minHeight: 32,
                  justifyContent: sideBarIsOpen ? "flex-start" : "center",
                  borderRadius: 1.2,
                  backgroundColor: item.url === pathname ? HNSColors.tertiary[900] : "transparent",
                }}
              >
                {sideBarIsOpen && (
                  <>
                    {isUserManagement && (
                      <ListItemIcon
                        sx={{
                          minWidth: 32,
                          justifyContent: "center",
                          "& svg": {
                            color: HNSColors.neutrals[300],
                          },
                        }}
                      >
                        {item.icon}
                      </ListItemIcon>
                    )}
                    <ListItemText
                      primary={item.title}
                      sx={{
                        ml: isUserManagement ? 1 : 0,
                        span: { fontSize: 13 },
                        color: item.url === pathname && HNSColors.primary[500],
                      }}
                    />
                  </>
                )}
              </ListItemButton>
            </div>
          ))}
        </List>
      </Collapse>
    </>
  );
}
